export const isScrolledToBottom = (el, tolerance = 2) => {
  if (!el) return false;
  const { scrollTop, scrollHeight, clientHeight } = el;
  return scrollTop + clientHeight >= scrollHeight - tolerance;
}



// WEBPACK FOOTER //
// ./src/containers/ChatsPage/utils/isScrolledToBottom.ts